import React, { useEffect, useState } from 'react';
import { Col, Container, FormControl, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../../styles/Forms.css';

export function StaffSection(props) {
    const [stateLicense, setStateLicense] = useState(props.member.stateLicense)
    const [jobTitle, setJobTitle] = useState(props.member.jobTitle)

    useEffect(() => {
        props.member.jobTitle = jobTitle;
        props.member.stateLicense = stateLicense;

        if (jobTitle && jobTitle !== "") {
            props.setStaffOkay();
        }
        else {
            props.setStaffNotOkay();
        }
    }, [stateLicense, jobTitle, props])

    return (
        <Container>
            <Row style={{ padding: "4px" }}>
                    <Col></Col>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip id="legal-name-tip">
                        Please include any leading letters. Example formats: MD-1234, MD1234
                    </Tooltip>}
                >
                    <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                        <div style={{ paddingRight: "5px" }}>State License Number</div>
                        <FormControl
                            type="text"
                            placeholder="State License Number"
                            defaultValue={(stateLicense && stateLicense !== "") ? stateLicense : undefined}
                            id="license"
                            name="license"
                            aria-label="license"
                            aria-describedby="license"
                            onChange={(e) => { setStateLicense(e.target.value) }}
                        />
                    </Col>
                </OverlayTrigger>
            </Row>
            <Row style={{ padding: "4px" }}>
                <Col sm={2}></Col>
                <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                    <div style={{ paddingRight: "5px" }}>Staff Job Title</div>
                    <FormControl
                        required={props.isStaff}
                        isInvalid={jobTitle === null || jobTitle === ""}
                        type="text"
                        placeholder="Staff Job Title"
                        id="staff-title"
                        name="staff-title"
                        aria-label="staff-title"
                        aria-describedby="staff-title"
                        defaultValue={(jobTitle && jobTitle !== "") ? jobTitle : ""}
                        onChange={(e) => { setJobTitle(e.target.value) }}
                    />
                </Col>
            </Row>
        </Container>
    );
}